import AlertManager from "./AlertManager";
export default AlertManager;
